




import { Component, Vue } from 'vue-property-decorator';
import { mapState, mapMutations } from 'vuex';

@Component({
  computed: {
    ...mapState(['route', 'isFirstPage']),
  },
  methods: mapMutations(['markFirstPage']),
})
export default class App extends Vue {
  private route: { path: string } = this.route;
  private isFirstPage: boolean = this.isFirstPage;

  private markFirstPage: () => void = this.markFirstPage;

  private keyListener(e: KeyboardEvent) {
    e.preventDefault();
    e.stopPropagation();

    if (e.keyCode === 27 && this.route.path !== '/') {
      if (this.isFirstPage) {
        this.markFirstPage();
        this.$router.replace('/');
      } else {
        this.$router.go(-1);
      }
    }
  }

  private created() {
    window.addEventListener('keyup', this.keyListener);
  }

  private destroyed() {
    window.removeEventListener('keyup', this.keyListener);
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue